module.exports = __webpack_public_path__ + "img/sun.17b27a0f.svg";